import { render, staticRenderFns } from "./ManagementWrapper.vue?vue&type=template&id=83840c60&"
import script from "./ManagementWrapper.vue?vue&type=script&lang=js&"
export * from "./ManagementWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ManagementWrapper.vue?vue&type=style&index=0&id=83840c60&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports